module.exports = {
  DragDrop: {
    PluginName: "Drag Drop",
    content_box_name: "Content ",
    Statement: "You can drag your correct answer",
    Question: "Question",
    Feedback: "Feedback",
    FeedbackMsg:
      "Here you can provide some feedback about the answer. In order to disable this feature, turn it off in the toolbar.",
    TrueFeedbackMsg:
      "Here you can provide some feedback about the true answer. In order to disable this feature, turn it off in the toolbar.",
    FalseFeedbackMsg:
      "Here you can provide some feedback about the false answer. In order to disable this feature, turn it off in the toolbar.",
    ShowFeedback: "Show feedback msg.",
    Number: "Number  of answers",
    ShowLettersInsteadOfNumbers: "Show letters instead of numbers",
    background_color: "Background color",
    border_color: "Border color",
    border_size: "Border Size",
    border_style: "Border Style",
    box_style: "Box style",
    opacity: "Opacity",
    padding: "Padding",
    pos: "Position",
    radius: "Radius",
    source: "Fuente",
    Answer: "Answer",
    Number: "Number",
  },
};
